(function (window, angular) {
    'use strict';

    var app = angular.module('app');

    /**
     *
     * lead App Controller
     *
     */
    app.controller('leadController', ['$scope', 'leadService', 'userService', '$filter', '$timeout', '$window', 'configService', 'agenceService', 'origineService', 'pipeService',
        function ($scope, leadService, userService, $filter, $timeout, $window, configService, agenceService, origineService, pipeService) {
            $scope.my_user_id = configService.uid;
            $scope.users = {};
            $scope.agencies = {};
            $scope.origines = {};
            $scope.statistics = null;
            $scope.leads = []; // all current leads
            $scope.status_options = [];
            $scope.loading = true;

            $scope.pager = {
                current_page: 1,
                total: 0,
                last_page: 0
            };

            /**
             * init controller
             * @return {none}
             */
            $scope.init = function () {
                if (!$scope.filters.date_type) {
                    $scope.resetFilters();
                }

                $scope.loading = true;
                origineService.search({only_leads: 1, only_parents: 1}).then(function (origines) {
                    $scope.origines = origines;
                    $scope.loadStatusOptions();
                });
                agenceService.search().then(function (agencies) {
                    $scope.agencies = agencies;
                });
                userService.search().then(function (users) {
                    $scope.users = {
                        array: users,
                    };
                    angular.forEach(users, function (user, idx) {
                        $scope.users['id' + user.id] = user;
                    });

                    $scope.search();
                });
            }

            $scope.setPeriodAndDateDypeFilterAndSearch = function (period, date_type) {
                $scope.setPeriodFilter(period);
                $scope.filters.date_type = date_type;
                $scope.search();
            }

            $scope.setPeriodFilterAndSearch = function (period) {
                $scope.setPeriodFilter(period);
                $scope.search();
            }

            $scope.resetFilters = function () {
                $scope.$parent.resetFilters();
                $scope.filters.date_type = 'int_lead_date';
            }

            $scope.resetFiltersAndSearch = function () {
                $scope.resetFilters();
                $scope.search();
            }

            $scope.getUser = function (user_id) {
                return $scope.users['id' + user_id];
            }

            $scope.go = function (url) {
                $window.location = url;
            }

            /**
             * search for leads
             * @return none
             */
            $scope.search = function (page) {
                $scope.loading = true;

                leadService.search($scope.filters, page).then(function (result) {
                    $scope.leads = result.data;
                    angular.forEach($scope.leads, function (lead, idx) {
                        $scope.initLead(lead);
                    });
                    $scope.pager = result;
                    $scope.indicators = result.extra;

                    $scope.loading = false;
                }, function (error) {
                    $scope.loading = false;
                });

                if (!page) {
                    // do not update while changing page
                    leadService.statistics($scope.filters).then(function (result) {
                        var total = parseInt(result.todo.total, 10)
                            + parseInt(result.pipe.total, 10)
                            + parseInt(result.done.total, 10);
                        var convertor = 0;
                        if (total > 0) {
                            convertor = 100.0 / total;
                        }
                        result.todo.percent = Math.floor(parseInt(result.todo.total, 10) * convertor);
                        result.pipe.percent = Math.floor(parseInt(result.pipe.total, 10) * convertor);
                        result.done.percent = Math.floor(parseInt(result.done.total, 10) * convertor);

                        var convertor = 0;
                        var done_total = parseInt(result.done.total, 10);
                        if (done_total > 0) {
                            convertor = 100.0 / done_total;
                        }

                        result.done.won_percent = Math.floor(parseInt(result.done.won) * convertor);
                        result.done.valid_percent = Math.floor(parseInt(result.done.valid) * convertor);

                        if (result.pipe.status) {
                            convertor = 0;
                            var todo_total = parseInt(result.todo.total);
                            if (todo_total > 0) {
                                convertor = 100.0 / todo_total;
                            }
                            angular.forEach(result.pipe.status, function (data) {
                                data.percent = Math.floor(parseInt(data.total, 10) * convertor);
                            });
                        }

                        $scope.statistics = result;
                    });
                }
            }

            /**
             * Add some usefull info for the view
             */
            $scope.initLead = function (lead) {
                lead.is_delegated_to_myself = false;
                angular.forEach(lead.users, function (user, idx) {
                    if (user.id == $scope.my_user_id) {
                        lead.is_delegated_to_myself = true;
                    }
                });

                lead.is_mine = lead.created_by_user_id == $scope.my_user_id; // am i the created_by_user ?
                lead.is_deletable = lead.created_by_user_id == $scope.my_user_id; // am i the created_by_user ?
                lead.status_finished = lead.is_mine ? 'closed' : 'done'; // finished at my level created_by_user or delegate

                lead.updated_by_user = $scope.getUser(lead.updated_by_user_id);
                lead.parrain = $scope.getUser(lead.int_lead_id_parrain);

                return lead;
            }

            /**
             * Delete a lead !
             * @param  {object} lead to delete
             * @return {none}
             */
            $scope.deleteLead = function (lead) {
                // check whether we know this lead
                var idx = $scope.leads.indexOf(lead);
                if (idx == -1 || !lead.is_mine) {
                    return;
                }

                leadService.delete(lead).then(function () {
                    $scope.leads.splice(idx, 1)
                });
            }

            /**
             * status filter is int_lead_status + int_id_pss filter
             * @return none
             */
            $scope.statusFilterChanged = function () {
                delete($scope.filters.int_lead_status);
                delete($scope.filters.int_id_pss);

                if ($scope.filters.status) {
                    var id = parseInt($scope.filters.status, 10);
                    if (id) {
                        $scope.filters.int_lead_status = 'pipe';
                        $scope.filters.int_id_pss = id;
                    }
                    else {
                        $scope.filters.int_lead_status = $scope.filters.status;
                    }
                }
                $scope.search();
            }

            /**
             * load all pipe status options depending on the filters.origine
             * @return none
             */
            $scope.loadStatusOptions = function () {
                $scope.status_options = [];

                if (!($scope.filters.origine && $scope.filters.origine.ore_id)) {
                    return;
                }

                if ($scope.filters.origine.ore_id_pie) {
                    pipeService.get($scope.filters.origine.ore_id_pie).then(function (pipe) {
                        if (pipe.status) {
                            $scope.status_options = pipe.status;
                        }
                    });
                }
            }

            $scope.origineFilterChanged = function () {
                delete($scope.filters.int_id_ore);
                // remove all status filters
                delete($scope.filters.status);
                $scope.statusFilterChanged();

                if ($scope.filters.origine && $scope.filters.origine.ore_id) {
                    $scope.filters.int_id_ore = $scope.filters.origine.ore_id;
                }

                $scope.loadStatusOptions();
                $scope.search();
            }

            $scope.createdByUserFilterChanged = function () {
                delete($scope.filters.created_by_user_id);

                if ($scope.filters.created_by_user && $scope.filters.created_by_user.id) {
                    $scope.filters.created_by_user_id = $scope.filters.created_by_user.id;
                }
                $scope.search();
            }

            $scope.delegatedToUserFilterChanged = function () {
                delete($scope.filters.int_id_usr_affect);

                if ($scope.filters.delegated_to_user && $scope.filters.delegated_to_user.usr_id) {
                    $scope.filters.int_id_usr_affect = $scope.filters.delegated_to_user.usr_id;
                }
                $scope.search();
            }

            $scope.delegatedToAgencyFilterChanged = function () {
                delete($scope.filters.int_id_age_affect);

                if ($scope.filters.delegated_to_agency && $scope.filters.delegated_to_agency.age_id) {
                    $scope.filters.int_id_age_affect = $scope.filters.delegated_to_agency.age_id;
                }
                $scope.search();
            }

            $scope.export = function () {
                leadService.export($scope.filters);
            }

            /**
             * getReferences
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            $scope.getReferences = function (val) {
                $scope.filters.int_lead_ref = val;

                return leadService.list($scope.filters).then(function (leads) {
                    return leads.map(function (lead) {
                        return lead.int_lead_ref;
                    });
                })
            }

            /**
             * getNoms
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            $scope.getNoms = function (val) {
                $scope.filters.int_lead_nom = val;

                return leadService.list($scope.filters).then(function (leads) {
                    return leads.map(function (lead) {
                        return lead.int_lead_nom;
                    });
                })
            }


        }]);

})(window, window.angular);
